export const AdsTypeFilter = (t: any) => [
  {
    label: t('adsType.session'),
    value: 'session',
  },
  {
    label: t('adsType.hearingCouncil'),
    value: 'hearingCouncil',
  },
];
